import * as Yup from 'yup';
import { TFunction } from 'i18next';
import { upperFirst } from 'lodash';

export default function validationSchema(t: TFunction) {
  return Yup.object({
    title: Yup.string().required().label(t('event.label.title')),
    from: Yup.date().required().label(t('event.label.from')),
    to: Yup.date().required().label(t('event.label.to')),
    description: Yup.string().label(t('event.label.description')).nullable(),
    categoryId: Yup.string().label(t('event.label.category')),
    participantIds: Yup.array()
      .of(Yup.string().uuid())
      .when('isPrivate', {
        is: true,
        then: (schema) => schema.min(1).required(),
        otherwise: (schema) => schema.optional(),
      })
      .label(t('event.label.participants')),
    isPrivate: Yup.boolean().required().label(t('event.label.isPrivate')),
  });
}

export function faqValidationSchema(t: TFunction) {
  return Yup.object({
    question: Yup.string()
      .required()
      .label(upperFirst(t('word.question', { ns: 'common' })))
      .min(3),
    answer: Yup.string()
      .required()
      .label(upperFirst(t('word.answer', { ns: 'common' })))
      .min(11)
      .test(
        'is-not-empty',
        upperFirst(t('word.answer', { ns: 'common' })),
        (value) => value !== '<p><br></p>'
      ),
  });
}

export function coverValidationSchema(t: TFunction) {
  return Yup.object({
    cover: Yup.mixed().label(t('event.label.cover')).nullable(),
  });
}
